import { type Component } from 'solid-js'
import { Trans } from '@mbarzda/solid-i18next'
import NoData from '../../../assets/images/no-data.svg'

const EmptyState: Component = () => {
  return (
    <div class="flex flex-col items-center justify-center py-[150px] px-4 text-center gap-2">
      <img src={NoData} alt="No data" />
      <h3 class="text-sm font-bold text-gray-700">
        <Trans key="ls_empty_state_no_data_title" />
      </h3>
      <p class="text-gray-500 max-w-md mx-auto text-xs w-[305px] font-normal">
        <Trans key="ls_empty_state_no_data_description" />
      </p>
    </div>
  )
}

export default EmptyState
